/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { node } from 'prop-types';
import withScript from '../../../../lib/scriptLoader';
import { cardIslePluginConfig } from '../../../../state/ducks/Checkout/ducks/Recipient/ducks/CardIsle/CardIsle-Helpers';

const { cardIslePdpURL } = cardIslePluginConfig;

const LoadCardIslePDPLib = ({ children }) => <>{children}</>;

LoadCardIslePDPLib.propTypes = {
    children: node,
};

LoadCardIslePDPLib.defaultProps = {
    children: null,
};

export default withScript(cardIslePdpURL, false, false)(LoadCardIslePDPLib);
